/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SalutationEnumDTO } from './salutation-enum-dto';


/**
 * Natural person details. *Natural person cannot be used together with Legal form.*
 */
export interface NaturalPersonDTO { 
    salutation: SalutationEnumDTO;
    /**
     * First name (Vorname)
     */
    firstName: string;
    /**
     * Last name (Name)
     */
    lastName: string;
    /**
     * Academic degree (Titel)
     */
    title?: string;
    /**
     * Prefixed parts of names and noble titles (Namensvorsatz)
     */
    namePrefix?: string;
    /**
     * Name affix (Namenszusatz)
     */
    nameAffix?: string;
    /**
     * Birth date (Geburtsdatum)
     */
    birthDate: string;
}

export class ClsNaturalPersonDTO { 
    salutation: SalutationEnumDTO = undefined;
    /**
     * First name (Vorname)
     */
    firstName: string = undefined;
    /**
     * Last name (Name)
     */
    lastName: string = undefined;
    /**
     * Academic degree (Titel)
     */
    title?: string = undefined;
    /**
     * Prefixed parts of names and noble titles (Namensvorsatz)
     */
    namePrefix?: string = undefined;
    /**
     * Name affix (Namenszusatz)
     */
    nameAffix?: string = undefined;
    /**
     * Birth date (Geburtsdatum)
     */
    birthDate: string = undefined;
}



